import React from 'react';
import PropTypes from 'prop-types';
import {geolocated} from 'react-geolocated';
import {setDeviceLocation} from  '../../actions/locationActions';

const geo = {
  positionOptions: {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: Infinity,
  },
  userDecisionTimeout : null,
  geolocationProvider : (typeof (navigator) !== 'undefined' && navigator.geolocation),
};

class DeviceLocation extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      coords: null,
      isGeolocationAvailable: Boolean(geo.geolocationProvider),
      isGeolocationEnabled: true, // be optimistic
      positionError: null,
    };

    if (geo.userDecisionTimeout) {
      this.geo.userDecisionTimeoutId = setTimeout(() => {
        this.onPositionError();
      }, geo.userDecisionTimeout);
    }

    this.onPositionError = this.onPositionError.bind(this);
    this.onPositionSuccess = this.onPositionSuccess.bind(this);
    this.cancelUserDecisionTimeout = this.cancelUserDecisionTimeout.bind(this);
  }

  componentDidMount() {
    if (!geo.geolocationProvider || !geo.geolocationProvider.getCurrentPosition) {
      throw new Error('The provided geolocation provider is invalid');
    }
    geo.geolocationProvider.getCurrentPosition(this.onPositionSuccess, this.onPositionError, geo.positionOptions);
  }

  cancelUserDecisionTimeout(unmounting = false) {
    if (this.userDecisionTimeoutId) {
      clearTimeout(this.userDecisionTimeoutId);
    }
    if (!unmounting && !this.loadPositionIntervalId) {
      this.loadPositionIntervalId = setInterval(function () {
        geo.geolocationProvider.getCurrentPosition(this.onPositionSuccess, this.onPositionError, geo.positionOptions);
      }.bind(this), 2500);
    } else if(unmounting && this.loadPositionIntervalId) {
      clearInterval(this.loadPositionIntervalId);
    }
  }

  onPositionError(positionError) {
    this.cancelUserDecisionTimeout();
    //console.log('position error', positionError);
    let newState = {
      coords: null,
      isGeolocationAvailable: this.state.isGeolocationAvailable,
      isGeolocationEnabled: false,
      positionError,
    };
    this.setState(newState);
    this.props.dispatch(setDeviceLocation(newState));
  }

  onPositionSuccess(position) {
    this.cancelUserDecisionTimeout();
    //console.log('loaded position', position);
    let newState = {
      coords: position.coords,
      isGeolocationAvailable: this.state.isGeolocationAvailable,
      isGeolocationEnabled: true,
      positionError: null,
    };
    this.setState(newState);
    this.props.dispatch(setDeviceLocation(newState));
  }

  componentWillUnmount() {
    this.cancelUserDecisionTimeout(true);
  }

  render() {
    let {isGeolocationAvailable} = this.state;
    return !isGeolocationAvailable ? <div className="text-warning">Your browser does not support Geolocation</div> :
      <div/>;
  }
}

DeviceLocation.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default DeviceLocation;